import { formatDuration, intervalToDuration } from 'date-fns'

interface TimeFormat {
  value: number
  format: string
}

export function convertMinutes(minutes: number): TimeFormat {
  const duration = intervalToDuration({ start: 0, end: minutes * 60 * 1000 })
  const formattedDuration = formatDuration(duration, {
    format: ['hours', 'minutes'],
  })

  if (formattedDuration.includes('hours')) {
    const hours = duration.hours || 0
    const format = hours === 1 ? 'hour' : 'hours'

    return { value: hours, format }
  } else {
    return { value: duration.minutes || 0, format: 'minutes' }
  }
}
